<div
  class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-ink/80 px-4 py-10"
  (click)="close()"
>
  <div
    class="w-full max-w-lg rounded-md border border-hairline bg-panel p-6"
    (click)="$event.stopPropagation()"
  >
    <div class="mb-4 flex items-start justify-between gap-4">
      <h2 class="font-display text-xl font-semibold text-parchment">
        Edit {{ competition().name }}
      </h2>
      <button
        type="button"
        (click)="close()"
        class="text-xl leading-none text-dusk hover:text-parchment"
        aria-label="Close"
      >
        &times;
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()" class="flex flex-col gap-3">
      <label class="flex flex-col gap-1 text-sm">
        <span class="text-dusk">Name</span>
        <input
          formControlName="name"
          type="text"
          class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
        />
      </label>

      <div class="grid grid-cols-3 gap-3">
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Start</span>
          <input
            formControlName="startDate"
            type="date"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">End</span>
          <input
            formControlName="endDate"
            type="date"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Submission cutoff</span>
          <input
            formControlName="submissionEndDate"
            type="date"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          />
        </label>
      </div>

      <div class="grid grid-cols-3 gap-3">
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Regular picks</span>
          <input
            formControlName="maxEntries"
            type="number"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Alternates</span>
          <input
            formControlName="maxAlternates"
            type="number"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Max age</span>
          <input
            formControlName="maxAge"
            type="number"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
          />
        </label>
      </div>

      @if (rosterRulesLocked()) {
        <p class="text-xs text-dusk">
          Roster rules are fixed on the Free plan — upgrade to change them.
        </p>
      }

      @if (saveError()) {
        <p class="rounded border border-wax/40 bg-wax/10 px-3 py-2 text-xs text-parchment">
          {{ saveError() }}
        </p>
      }

      <div class="mt-2 flex items-center gap-3">
        <button
          type="submit"
          [disabled]="saving()"
          class="inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
        >
          {{ saving() ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </form>

    <div class="mt-6 border-t border-hairline pt-4">
      @if (deleteError()) {
        <p class="mb-3 rounded border border-wax/40 bg-wax/10 px-3 py-2 text-xs text-parchment">
          {{ deleteError() }}
        </p>
      }
      @if (!confirmingDelete()) {
        <button
          type="button"
          (click)="confirmingDelete.set(true)"
          class="text-xs text-wax-bright hover:underline"
        >
          Delete this competition
        </button>
      } @else {
        <div class="flex items-center gap-3 text-xs">
          <span class="text-parchment">Delete permanently? This can't be undone.</span>
          <button
            type="button"
            (click)="confirmDelete()"
            [disabled]="deleting()"
            class="rounded-[3px] border border-wax-bright px-3 py-1.5 font-semibold text-wax-bright transition hover:bg-wax/10 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {{ deleting() ? 'Deleting…' : 'Yes, delete' }}
          </button>
          <button
            type="button"
            (click)="confirmingDelete.set(false)"
            class="text-dusk hover:text-parchment"
          >
            Cancel
          </button>
        </div>
      }
    </div>
  </div>
</div>
